exports.jsonToBr = function (str) {
    return str.replace(/\\n/g, "<br/>").replace(/\n/g, "<br/>");
}